import { KeyAndScale } from '@arpeggi/shared'
import { ComponentProps, FC, useMemo } from 'react'
import { ChevronDown } from '../../../core/icons'
import { DEFAULT_KEY } from '../hooks/useSongs'
import * as Dropdown from './Dropdown'

interface Key {
  label: string
  value: number
}

const segmentTrackKey = (index) => {
  const key = KeyAndScale.from(index)
  const label = key.displayName()
  window.analytics.track('Button Clicked', {
    button: 'key',
    filter: label
  })
}

const generateKeys = (): Key[] => {
  const result: Key[] = []
  for (let i = 0; i < 13; i++) {
    const key = KeyAndScale.from(i)
    result.push({ label: key.displayName(), value: key.toInt() })
  }
  return result
}

type KeyDropdownProps = { _key: number | undefined; onSelect?: (key: number) => void } & Omit<
  ComponentProps<typeof Dropdown.Trigger>,
  'onSelect'
>

const KeyDropdown: FC<KeyDropdownProps> = ({ _key, onSelect, ...props }) => {
  const keys = useMemo(() => generateKeys(), [])
  const handleSelect = (value: number) => (evt) => {
    evt.preventDefault()
    onSelect(value)
    segmentTrackKey(value)
  }
  return (
    <Dropdown.Root>
      <Dropdown.Trigger active={_key !== DEFAULT_KEY} {...props}>
        Key
        <ChevronDown />
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content side={'bottom'} align={'start'} sideOffset={4}>
          {keys.map(({ value, label }, i) => (
            <Dropdown.CheckboxItem
              key={value}
              onSelect={handleSelect(value)}
              checked={value === _key}
            >
              {label}
            </Dropdown.CheckboxItem>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  )
}

export default KeyDropdown
